// used for congress trades
// activity chart with just counts and no guru names

const d3 = require('d3');
import { getParent } from '../utilities';

export default function (chartEl, boxes, prices, activeTimePeriod) {
  let minDate, maxDate, maxTransactionValue;
  const boxesContainer = d3
    .select(chartEl)
    .append('div')
    .attr('class', 'activitiy-chart__container');
  const politicianId = chartEl.getAttribute('data-politician-id');

  init();

  function init() {
    maxTransactionValue = maxValue(boxes);
    renderChart();
  }

  function renderChart() {
    minDate = prices[0].date;
    maxDate = prices[prices.length - 1].date;
    const times = monthsBetween(minDate, maxDate);
    let month = minDate.getUTCMonth() + 1;
    let year = minDate.getUTCFullYear();

    for (let i = 0; i < times; i++) {
      const box = boxes[month + '-' + year];
      const style = firstAndLastBoxStyle(i, times, minDate, maxDate);
      createBox(box, style, month, year);

      if (month >= 12) {
        month = 1;
        year += 1;
      } else {
        month += 1;
      }
    }
  }

  function resize(newPrices, _newYAxisLimits, newActiveTimePeriod) {
    prices = newPrices;
    activeTimePeriod = newActiveTimePeriod;
    boxesContainer.html('');
    renderChart();
  }

  function reset(newPrices, newBoxes) {
    prices = newPrices;
    boxes = newBoxes;
    maxTransactionValue = maxValue(boxes);
    boxesContainer.html('');
    renderChart();
  }

  function createBox(box, style, month, year) {
    const container = boxesContainer.append('div')
      .attr('class', 'activitiy-chart__boxes')
      .attr('style', style);

    if (box && (box.buys || box.sells)) {
      const monthName = d3.timeFormat('%b')(new Date(year, month - 1));
      container.attr('data-month', monthName + ' ' + year)
        .attr('data-buys', box.buys)
        .attr('data-sells', box.sells)

      container.append('div').attr('class', 'activitiy-chart__box--buy')
        .attr('style', 'height: ' + box.buys / maxTransactionValue * 100 / 2 + '%');
      container.append('div').attr('class', 'activitiy-chart__box--sell')
        .attr('style', 'height: ' + box.sells / maxTransactionValue * 100 / 2 + '%');

      container.node().addEventListener('mouseover', showTooltip);
    }
  }

  function hideTooltip(event) {
    const el = getParent(event.target, 'activitiy-chart__boxes');
    el.removeEventListener('mouseleave', hideTooltip);
    el.querySelector('div:last-child').remove();
    el.addEventListener('mouseover', showTooltip);
  }
  
  function showTooltip(event) {
    const el = getParent(event.target, 'activitiy-chart__boxes');
    el.removeEventListener('mouseover', showTooltip);
  
    const container = document.createElement('div');
  
    const header = document.createElement('header');
    let text = document.createTextNode(el.dataset.month);
    header.appendChild(text);
  
    const buys = document.createElement('p');
    buys.dataset.type = 'buy';
    if (el.dataset.buys === '0') {
      buys.classList.add('activitiy-chart__tooltip-text--muted');
    }
    text = document.createTextNode(transactionText(el.dataset.buys, 'bought'));
    buys.appendChild(text);
  
    const sells = document.createElement('p');
    sells.dataset.type = 'sell';
    if (el.dataset.sells === '0') {
      sells.classList.add('activitiy-chart__tooltip-text--muted');
    }
    text = document.createTextNode(transactionText(el.dataset.sells, 'sold'));
    sells.appendChild(text);
  
    container.appendChild(header);
    container.appendChild(buys);
    container.appendChild(sells);
    container.classList.add('activitiy-chart__tooltip');
    el.appendChild(container);
    if (container.getBoundingClientRect().right > window.innerWidth) {
      container.classList.add('activitiy-chart__tooltip--right');
    }
    el.addEventListener('mouseleave', hideTooltip);
  }
  
  function transactionText(count, type) {
    const text = politicianId ? 'stock' : 'politician';

    if (count === '0') {
      return 'No ' + text + ' ' + type;
    }
  
    return pluralize(text, count) + ' ' + type;
  }

  return {
    resize: resize,
    reset: reset,
  };
}

function monthsBetween(startDate, endDate) {
  const yearsBetween = endDate.getUTCFullYear() - startDate.getUTCFullYear();
  const monthsBetween = endDate.getUTCMonth() - startDate.getUTCMonth();
  return yearsBetween * 12 + monthsBetween + 1;
}

function firstAndLastBoxStyle(i, times, startDate, endDate) {
  let style;
  if (i === 0) {
    style = 'flex: ' + (1 - monthProgress(startDate));
  } else if (i === times - 1) {
    style = 'flex: ' + monthProgress(endDate);
  }
  return style;
}

function monthProgress(date) {
  return date.getUTCDate() / 30;
}

function maxValue(obj) {
  let max = 1;

  Object.keys(obj).forEach(key => {
    const value = Math.max(obj[key]['sells'], obj[key]['buys']);
    if (value > max) {
      max = value;
    }
  });

  return max;
}

function pluralize(text, count) {
  if (count === '1') {
    return count + ' ' + text;
  }

  return count + ' ' + text + 's';
}